import AppManager from "src/services/app-manager"
import "styles/global.scss"
import wrapWithProvider from "./wrap-with-provider"

export const wrapRootElement = wrapWithProvider

export const onRouteUpdate = ({ location, prevLocation }) => AppManager.getInstance().onRouteUpdate(location, prevLocation)
export const onClientEntry = async () => AppManager.getInstance().onClientEntry()
